export default {
  toasts: {
    load_error: 'Maksuasetusten lataaminen epäonnistui',
    rails_saved: 'Maksukanavat tallennettu',
    gateway_registered: 'Maksuyhdyskäytävä rekisteröity',
    redact_failed: 'Maksuyhdyskäytävän poistaminen epäonnistui',
    gateway_redacted: 'Yhdyskäytävä poistettu',
    sca_provisioned: '3DS2-rekisteröinti luotu',
    company_assigned: 'Ravintola liitetty',
    default_set: 'Oletusyhdyskäytävä asetettu – uudet ravintolat liitetään siihen automaattisesti',
    default_failed: 'Oletusyhdyskäytävän asettaminen epäonnistui',
    primary_switched: 'Ensisijainen yhdyskäytävä vaihdettu: {{gateway}}',
    primary_switch_failed: 'Ensisijaisen yhdyskäytävän vaihtaminen epäonnistui',
  },
  custody: {
    title: 'Kuka käsittelee maksut',
    description:
      'Päätetään kerran, ensimmäisen maksukanavan tallennuksen yhteydessä, ja lukitaan sen jälkeen: omalla yhdyskäytävällä kumppani pitää varat hallussaan; FoodAmigosin Adyen-tilillä FoodAmigos pitää ne hallussaan ja maksaa kumppanin osuuden kuukausittain.',
    options: {
      provider: 'Kumppanin oma yhdyskäytävä',
      platform: 'FoodAmigos käsittelee maksut',
    },
    locked_notice: 'Lukittu kohteeseen ”{{custodian}}” maksuasetusten mukaan – sitä ei voi muuttaa.',
    pick_first: 'Valitse ensin, kuka käsittelee maksut.',
    lock_confirm: {
      title: 'Lukitaanko maksut kohteeseen ”{{custodian}}”?',
      description:
        'Tallentaminen nyt päättää, kuka pitää hallussaan tämän kumppanin varat, eikä sitä voi perua – ei täällä eikä tuen kautta. Maksukanavaa voi vielä vaihtaa myöhemmin, mutta sitä, kuka käsittelee maksut, ei voi.',
      confirm: 'Lukitse ja tallenna',
    },
  },
  rails: {
    title: 'Maksukanava',
    description:
      'Mitä maksupalveluntarjoajaa tämä kumppani käyttää – vain yhtä kerrallaan. Ravintoloita voi vaihtaa vain tässä valittuun kanavaan, eikä kanavaa voi vaihtaa, jos ravintolat yhä veloittavat sitä käyttäen.',
    save: 'Tallenna kanava',
    multiple_warning:
      'Tämä kumppani käyttää yhä useampaa kuin yhtä kanavaa ({{rails}}). Tallentaminen säilyttää vain yllä valitun; muut poistetaan, ja muutos estetään kokonaan, jos jokin ravintola yhä veloittaa jotakin niistä.',
    options: {
      stripe: 'Stripe',
      adyen: 'Adyen',
      spreedly: 'Paikallinen yhdyskäytävä Spreedlyn kautta',
    },
    platform_stripe_unavailable: 'Stripe FoodAmigosin tileillä ei ole vielä käytettävissä.',
    platform_custody_notice: 'Ei käytettävissä, kun FoodAmigos käsittelee maksut.',
    provider_custody_adyen_notice:
      'Ei käytettävissä, kun kumppani tuo oman yhdyskäytävänsä – Adyen on FoodAmigosin käsittelykanava.',
  },
  spreedly_section_title: 'Spreedly-asetukset',
  gateways: {
    title: 'Yhdyskäytävät',
    description:
      'Kumppanin omat maksupalveluntarjoajan tilit. Koko veloitus tilitetään valitun yhdyskäytävän hankkijapankille.',
    register: 'Rekisteröi yhdyskäytävä',
    empty: 'Yhdyskäytäviä ei ole vielä rekisteröity',
    columns: {
      gateway: 'Yhdyskäytävä',
      status: 'Tila',
      sca: '3DS2',
      companies: 'Ravintolat',
    },
    statuses: {
      active: 'Aktiivinen',
      redacted: 'Poistettu',
    },
    sca: {
      sandbox: '3DS2-testiympäristö',
      live: '3DS2-tuotantoympäristö',
      none: 'Ei 3DS2:ta',
    },
    default_tag: 'Oletus',
    actions: {
      make_default: 'Aseta oletukseksi',
      check: 'Suorita tarkistus…',
      sca_provision: 'Määritä 3DS2…',
      sca_manage: '3DS2-rekisteröinti…',
      redact: 'Poista yhdyskäytävä (redact)',
    },
  },
  redact_confirm: {
    title: 'Poistetaanko {{gateway}}?',
    description:
      'Tunnistetiedot poistetaan Spreedlystä, eikä niitä voi palauttaa. {{count}} liitetty(ä) ravintola(a) veloittaa yhä tämän yhdyskäytävän kautta — niin kauan kuin yhtään on liitetty, poistoa ei sallita, vaan sinua pyydetään vahvistamaan uudelleen.',
    redact: 'Poista',
    force_title: 'Poistetaanko {{gateway}} silti?',
    force_description:
      '{{count}} ravintola(a) on yhä liitetty tähän yhdyskäytävään. Jos poistat sen nyt, niiden kassa estyy, kunnes kullekin on asetettu toinen yhdyskäytävä. Tätä ei voi perua.',
    force_redact: 'Poista silti',
  },
  companies: {
    title: 'Ravintolat',
    description: 'Minkä maksunvälittäjän kautta kukin ravintola veloittaa, ja sen Spreedly-yhdyskäytävän liitos.',
    empty: 'Ei ravintoloita',
    no_gateway: 'Ei mitään',
    unassigned: 'Ei liitetty',
    // The default gateway is assigned at creation and never fails the creation —
    // so a restaurant can end up unassigned with the reason only in the log.
    assignment_error_label: 'Automaattinen liittäminen epäonnistui',
    assign: 'Liitä',
    reassign: 'Liitä uudelleen',
    columns: {
      restaurant: 'Ravintola',
      primary_gateway: 'Ensisijainen yhdyskäytävä',
      spreedly: 'Spreedly-yhdyskäytävä',
    },
    switch_primary_to: 'Vaihda yhdyskäytäväksi {{gateway}}',
    assign_modal: {
      title: 'Liitä {{company}} yhdyskäytävään',
      assign: 'Liitä',
      gateway: 'Yhdyskäytävä',
      make_primary: 'Tee Spreedlystä myös ensisijainen yhdyskäytävä',
      make_primary_hint: 'Veloitukset kulkevat vain Spreedlyn kautta, kun se on ensisijainen yhdyskäytävä.',
    },
  },
  register_modal: {
    title: 'Rekisteröi yhdyskäytävä',
    register: 'Rekisteröi',
    gateway_type: 'Yhdyskäytävän tyyppi',
    gateway_type_placeholder: 'Hae Spreedlyn luettelosta…',
    auth_mode: 'Tunnistautumistapa',
    no_credentials: 'Tämä yhdyskäytävätyyppi ei tarvitse tunnistetietoja (Spreedly-hiekkalaatikko).',
    description: 'Kuvaus',
    description_placeholder: 'esim. Acme Eats — Braintree EUR',
    acquirer_merchant_id: 'Hankkijan kauppiastunnus',
    acquirer_hint: 'Valinnainen — vaaditaan yhdessä MCC:n kanssa',
    mcc: 'MCC',
    mcc_hint: '4 numeroa, esim. 5812',
    make_default: 'Käytä partnerin oletuksena',
    make_default_hint:
      'Partnerin uudet ravintolat ja ne, joilla ei vielä ole yhdyskäytävää, kiinnitetään siihen. Jätä valitsematta, kun kyseessä on yhden ravintolan oma hankkija.',
  },
  sca_modal: {
    title: '3DS2-rekisteröinti — {{gateway}}',
    provision: 'Luo',
    irreversible_warning:
      'Peruuttamatonta: kauppiasprofiilia eikä SCA-tarjoajaa voi muokata tai poistaa jälkikäteen. Väärä hankkijan BIN-tunnus paljastuu vasta veloitushetkellä. Tarkista kaikki arvot hankkijapankilta ennen käyttöönottoa.',
    already_provisioned:
      'Jo luotu (tarjoajatunniste {{token}}). Uudelleen luominen palauttaa olemassa olevan rekisteröinnin, ellei "Luo uudelleen" ole käytössä.',
    type: {
      label: 'Tarjoajan tyyppi',
      hint: '"Testi" simuloi tunnistautumisen lopputuloksia ja hylätään tuotannossa.',
      test: 'Testi (SCA-hiekkalaatikko)',
      live: 'Tuotanto (Spreedly 3DS2 Global)',
    },
    country: {
      hint: 'Maa, jonka alle hankkijapankki rekisteröi tämän kauppiaan — ei välttämättä sama kuin partnerin rekisteröintimaa. Koskee kaikkia alla olevia korttiverkkoja.',
      differs_warning:
        'Tämä ei ole partnerin maa ({{country}}). Korjaa, jos hankkija rekisteröi kauppiaan muualle; tarkista muuten huolella, sillä kauppiasprofiilia ei voi muokata luomisen jälkeen.',
    },
    network_placeholder: 'Korttiverkko',
    add_network: 'Lisää korttiverkko',
    networks: {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
      discover: 'Discover',
      diners: 'Diners',
      jcb: 'JCB',
      dankort: 'Dankort',
      union_pay: 'UnionPay',
      cartes_bancaires: 'Cartes Bancaires',
    },
    fields: {
      acquirer_merchant_id: 'Hankkijan kauppiastunnus',
      acquirer_bin: 'Hankkijan BIN',
      mcc: 'MCC',
      merchant_name: 'Kauppiaan nimi',
      country_code: 'Maa (ISO-2)',
      merchant_url: 'Kauppiaan URL',
    },
    recreate: {
      label: 'Luo rekisteröinti uudelleen',
      hint: 'Hylkää nykyinen kauppiasprofiili ja SCA-tarjoaja lopullisesti ja luo uudet.',
    },
  },
  check_modal: {
    title: 'Tarkista yhdyskäytävä — {{gateway}}',
    run: 'Suorita tarkistus',
    done: 'Valmis',
    failed: 'Tarkistusta ei voitu suorittaa.',
    types: {
      verify: 'Vahvista (rahaa ei liiku)',
      test_payment: 'Testiveloitus',
    },
    verify_unsupported: 'Tämä yhdyskäytävätyyppi ei tue vahvistusta — suorita sen sijaan testiveloitus.',
    test_payment_warning:
      'Tuotannollisella yhdyskäytävällä tehdään oikea veloitus, joka hyvitetään heti takaisin. SCA-markkinoiden yhdyskäytävillä liikkeeseenlaskija voi hylätä ei-3DS-testin — se silti todistaa, että tunnistetiedot saavuttivat hankkijan.',
    amount: 'Summa',
    amount_help: 'Väliltä 1,00–5,00',
    check_passed: 'Tarkistus onnistui',
    check_failed: 'Tarkistus epäonnistui — katso vaiheet alla',
    legs: {
      verify: 'Vahvistus',
      purchase: 'Veloitus',
      credit: 'Hyvitys',
    },
    leg_passed: 'Onnistui',
    leg_failed: 'Epäonnistui',
  },
  card_fields: {
    script_failed: 'Spreedly-skriptiä ei voitu ladata. Tarkista verkkoyhteys ja yritä uudelleen.',
    full_name: 'Kortinhaltijan nimi',
    number: 'Kortin numero',
    expiry: 'Voimassaolo',
    cvv: 'CVV',
  },
};
